import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=0cb71bc6&"
import script from "./LayoutMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports